var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReason3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1116.082 2272.045 84.564 93.842",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Urban_Renewal_Tool_-_Homepage_1366px_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4535
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Urban_Renewal_Tool_-_Homepage_1366px_",
    "data-name": "Urban Renewal Tool - Homepage 1366px ",
    className: "cls-3",
    style: {
      clipPath: "url(#clip-Urban_Renewal_Tool_-_Homepage_1366px_)"
    },
    transform: "matrix(1, 0, 0, 1, 67.621826, -1705.269897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hp_impact_renewal_icon4",
    "data-name": "hp_impact renewal_icon4",
    transform: "matrix(1, 0, 0, 1, 1501.016479, 3543.405273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    className: "cls-1022",
    d: "M6487.718,7265.919h12.7l-3.178,6.354,3.178,6.354H6487.7v-3.177",
    transform: "translate(-6432.413 -7262.742)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    className: "cls-1022",
    d: "M6471.434,7262.3h14.3v12.709h-14.3",
    transform: "translate(-6430.751 -7262.304)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(0 1.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    className: "cls-1014",
    d: "M6437.537,7310.06l-8.366-5.976a3.6,3.6,0,0,1-.96-4.837l2.46-3.936a12.555,12.555,0,0,1,10.65-5.9h24.812s.364,5.394-4.765,6.354c-3.1.58-11.121,1.588-11.121,1.588v7.94l7.943,11.116v11.128",
    transform: "translate(-6426.417 -7266.253)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    className: "cls-1014",
    d: "M6446.131,7338.766l1.588-22.241,6.355,6.354v7.943",
    transform: "translate(-6428.264 -7269.019)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    className: "cls-1014",
    d: "M6426.245,7345.5l8.117-3.177h6.966l2.773-1.589h4.87l3.247-7.943h6.493l4.87,3.177h6.493l3.247,3.177h6.493l6.493,6.354",
    transform: "translate(-6426.245 -7270.991)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    className: "cls-1014",
    d: "M6435.284,7301.844l3.177-1.59v38.128",
    transform: "translate(-6427.34 -7267.046)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    className: "cls-1014",
    y2: 36.538,
    transform: "translate(38.878 28.442)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    className: "cls-1014",
    y2: 22.241,
    transform: "translate(38.878)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    className: "cls-1035",
    d: "M6446.233,7282.491a5.653,5.653,0,0,0,5.812-5.979v-2.989a5.815,5.815,0,1,0-11.625,0v2.989A5.653,5.653,0,0,0,6446.233,7282.491Z",
    transform: "translate(-6427.665 -7264.516)",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    className: "cls-1014",
    d: "M6489.08,7269.521h9.532l-3.177,6.354,3.177,6.354H6485.9v-3.177",
    transform: "translate(-6432.195 -7264.756)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    className: "cls-1014",
    d: "M6469.632,7265.906h14.3v12.709h-14.3",
    transform: "translate(-6430.543 -7264.317)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hp_impact_renewal_icon3",
    "data-name": "hp_impact renewal_icon3",
    transform: "matrix(1, 0, 0, 1, 1054.70105, 3989.576904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    className: "cls-1037",
    d: "M6469.892,7131.747h7.117l2.847-5.694h7.117l5.694-14.234h4.271",
    transform: "translate(-6435.208 -7103.57)",
    style: {
      fill: "none",
      stroke: "rgb(215, 220, 228)",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    className: "cls-1014",
    d: "M6453.59,7170.6v-40.039h7.813c4.716,0,6.251-2.852,6.251-6.405h-28.13c-2.93,0-7.813,2.421-7.813,9.609v11.211a6.464,6.464,0,0,0,6.25,6.406",
    transform: "translate(-6431.712 -7105.065)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    className: "cls-1014",
    y2: 35.943,
    transform: "translate(6.251 28.785)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    className: "cls-1014",
    width: 12.147,
    height: 14.946,
    rx: 6.074,
    transform: "translate(7.814)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    className: "cls-1014",
    y2: 23.441,
    transform: "translate(14.064 41.287)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(28.991 0.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    className: "cls-1014",
    d: "M6463.413,7116.839V7102.6h37.009v39.856h-37.009V7132.5",
    transform: "translate(-6463.413 -7102.604)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    className: "cls-1014",
    d: "M6469.892,7136.491h7.117l2.847-5.693h7.117l5.694-14.234h4.271",
    transform: "translate(-6464.199 -7104.297)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason3);
export default __webpack_public_path__ + "static/media/reason3.f425b9a0e3c5e049141ecdc9cb2ebd85.svg";
export { ForwardRef as ReactComponent };